import { render, staticRenderFns } from "./SecretariaVirtualnew.vue?vue&type=template&id=71a0ebef&scoped=true"
import script from "./SecretariaVirtualnew.vue?vue&type=script&lang=js"
export * from "./SecretariaVirtualnew.vue?vue&type=script&lang=js"
import style0 from "./SecretariaVirtualnew.vue?vue&type=style&index=0&id=71a0ebef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0ebef",
  null
  
)

export default component.exports